// extracted by mini-css-extract-plugin
export default {"outerForm":"userInput_outerForm__cifGZ","innerForm1":"userInput_innerForm1__GY9WO","innerForm2":"userInput_innerForm2__AByUZ","button":"userInput_button__sEFTw"};